/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import type { StylesObject } from "./utils/prefixStyles";

// Flow doesn't have types for SVGElements yet... We'll use Element as a
// stand-in
type SVGSVGElement = Element;

type Props = {
  modifiers: Array<string>,
  color?: ?string,
  size?: ?(string | number),
  style?: ?StylesObject,
  innerRef?: ?(?SVGSVGElement) => void,
  colors: ColorSet,
};

class IconBase extends React.Component<Props> {
  static defaultProps = {
    modifiers: [],
  };

  render() {
    const {
      modifiers,
      color,
      size,
      style,
      innerRef,
      colors,
      ...domAttrs
    } = this.props;

    const baseStyle = {
      verticalAlign: "middle",
    };

    const alertStyle = {
      ...baseStyle,
      color: colors.RED,
    };

    const warningStyle = {
      ...baseStyle,
      color: colors.WARNING,
    };

    const emergencyStyle = {
      ...baseStyle,
      color: colors.RED,
    };

    const computedSize = size || "1em";
    let computedStyle = baseStyle;

    modifiers.forEach((modifier) => {
      if (
        modifier === "alert" ||
        modifier === "insecure" ||
        modifier === "disconnected"
      ) {
        computedStyle = alertStyle;
      } else if (modifier === "warning") {
        computedStyle = warningStyle;
      } else if (modifier === "emergency") {
        computedStyle = emergencyStyle;
      }
    });

    // Try to re-use the same style object if we can. But if they passed a `color`
    // or `style` prop, we have to make a new one.
    let svgStyle;
    if (style || color) {
      svgStyle = {
        ...computedStyle,
        ...(color
          ? {
              color,
            }
          : null),
        ...style,
      };
    } else {
      svgStyle = computedStyle;
    }

    return (
      <svg
        fill="currentColor"
        preserveAspectRatio="xMidYMid meet"
        height={svgStyle.height || computedSize}
        width={svgStyle.width || computedSize}
        {...domAttrs}
        ref={innerRef}
        style={svgStyle}
      />
    );
  }
}

export default withColorsProvider(IconBase);



// WEBPACK FOOTER //
// ../nx-components/src/IconBase.jsx